export const DIET = [
  "",
  "pescetarian",
  "lacto vegetarian",
  "ovo vegetarian",
  "vegan",
  "vegetarian",
];

export const INTOLERANCES = [
  "dairy",
  "egg",
  "gluten",
  "peanut",
  "sesame",
  "seafood",
  "shellfish",
  "soy",
  "sulfite",
  "tree nut",
  "wheat",
];
export const DISH_TYPE = [
  "",
  "main course",
  "side dish",
  "dessert",
  "appetizer",
  "salad",
  "bread",
  "breakfast",
  "soup",
  "beverage",
  "sauce",
  "drink",
];
export const CUISINE = [
  "",
  "african",
  "chinese",
  "japanese",
  "korean",
  "vietnamese",
  "thai",
  "indian",
  "british",
  "irish",
  "french",
  "italian",
  "mexican",
  "spanish",
  "middle eastern",
  "jewish",
  "american",
  "cajun",
  "southern",
  "greek",
  "german",
  "nordic",
  "eastern european",
  "caribbean",
  "latin american",
];

export const RECIPE_TAGS = [
  "vegetarian",
  "vegan",
  "glutenFree",
  "dairyFree",
  "veryHealthy",
  "ketogenic",
];

export const QUICK_MENU = [
  {
    id: 10,
    name: "Chicken Recipes",
    searchTerm: "chicken",
    image: "images/chicken.jpg",
  },
  {
    id: 20,
    name: "Beef Recipes",
    searchTerm: "beef",
    image: "images/beef.jpg",
  },
  {
    id: 30,
    name: "Fish Recipes",
    searchTerm: "fish",
    image: "images/fish.jpg",
  },
  {
    id: 40,
    name: "Pasta Recipes",
    searchTerm: "pasta",
    image: "images/pasta.jpg",
  },
];

// const cooking =
//   'Photo by <a href="https://unsplash.com/@foodfaithfit?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Taylor Kiser</a> on <a href="/s/photos/cooking?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a>';
